import { RouteDefinition } from '@core/interfaces/route.interface';
import {
	adapterActions,
	IAdapterActions
}                          from '@core/store/adapter/adapter.actions';


export interface IRouterActions extends IAdapterActions<RouteDefinition> {
	// updateRouterState: ActionTypeWithProps<IPropsUpdateRouterState>;
}


// export interface IPropsUpdateRouterState extends IBaseProps {
// 	stateUpdateData?: RouterState;
// }


export function routerActions( storeId: string ) {
	return {
		// AdapterActions ##########################################################################################################################
		...adapterActions<RouteDefinition>( storeId )

		// ROUTER SPECIFIC ACTIONS ###########################################################################################################
		// updateRouterState: createAction( `[${ storeId }] State Update`, props<IPropsUpdateRouterState>() ),
	};
}
